// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.display-inline > div[data-v-b9497ce8] {\n  display: inline-block;\n}\n.padding[data-v-b9497ce8] {\n  padding: 0 1.15rem;\n}\n", ""]);
// Exports
module.exports = exports;
